import React from 'react'
import { Link } from 'react-router-dom'
import ListMenuButton from 'src/components/PageActions/ListMenuButton'
import PageActions from 'src/components/PageActions'
import PencilIcon from 'assets/icons/pencil'

const ExploreActions = () => (
   <PageActions
      editMenuOptions={(
         <Link to="/explore/edit">
            <ListMenuButton
               name="Edit Explore Page"
               description="Edit Explore page layout and content"
               icon={(
                  <PencilIcon
                     width="16px"
                     height="16px"
                     color="#aaa"
                  />
               )}
            />
         </Link>
      )}
   />
)

export default ExploreActions
